import Logo from './uc-compass-lockup-in-dark-blue.svg';
import './style.scss';

const Wordmark = () => {
  return (
    <div className="logo-container">
      <img src={Logo} alt="Compass Logo"/>
    </div>
  );
}

export default Wordmark;
